export const AGENT_DEPLOY_COMMAND =
  'Use skill `opendeploy` to create and deploy a new OpenDeploy project from the current repo.'
export const OTHER_AGENTS_INSTALL_COMMAND =
  'Read https://opendeploy.dev/start and install OpenDeploy for this agent, then ask me whether to deploy the current project.'

export interface AgentInstallExample {
  name: string
  installCommands: string[]
  updateCommands: string[]
}

export const AGENT_INSTALL_EXAMPLES: AgentInstallExample[] = [
  {
    name: 'Claude Code',
    installCommands: [
      'claude plugin marketplace add https://github.com/opendeploy-dev/opendeploy-claude-plugin',
      'claude plugin install opendeploy@opendeploy',
    ],
    updateCommands: [
      'claude plugin marketplace update opendeploy',
      'claude plugin update opendeploy@opendeploy',
    ],
  },
  {
    name: 'Codex',
    installCommands: [
      'codex plugin marketplace add opendeploy-dev/opendeploy-codex-plugin --ref main',
    ],
    updateCommands: [
      'codex plugin marketplace upgrade opendeploy',
    ],
  },
  {
    name: 'Cursor',
    installCommands: [
      '/add-plugin https://github.com/opendeploy-dev/opendeploy-cursor-plugin',
    ],
    updateCommands: [
      '/add-plugin https://github.com/opendeploy-dev/opendeploy-cursor-plugin',
    ],
  },
  {
    name: 'OpenCode',
    installCommands: [
      'curl -fsSL https://raw.githubusercontent.com/opendeploy-dev/opendeploy-opencode/main/install.sh | bash',
    ],
    updateCommands: [
      'curl -fsSL https://raw.githubusercontent.com/opendeploy-dev/opendeploy-opencode/main/install.sh | bash',
    ],
  },
  {
    name: 'OpenClaw',
    installCommands: [
      'openclaw plugins install clawhub:opendeploydev',
      'openclaw gateway restart',
    ],
    updateCommands: [
      'openclaw plugins update opendeploydev',
      'openclaw gateway restart',
    ],
  },
]
